import { render, staticRenderFns } from "./JobTemplatesTable.vue?vue&type=template&id=3b2abbb6&scoped=true&"
import script from "./JobTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./JobTemplatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2abbb6",
  null
  
)

export default component.exports